import { render } from "./DeleteMenu.vue?vue&type=template&id=4f00b8f9"
import script from "./DeleteMenu.vue?vue&type=script&lang=js"
export * from "./DeleteMenu.vue?vue&type=script&lang=js"

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteMenu.vue"]])

export default __exports__